import { render, staticRenderFns } from "./BoxContent1.vue?vue&type=template&id=424f1156&scoped=true"
import script from "./BoxContent1.vue?vue&type=script&lang=js"
export * from "./BoxContent1.vue?vue&type=script&lang=js"
import style0 from "./BoxContent1.vue?vue&type=style&index=0&id=424f1156&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424f1156",
  null
  
)

export default component.exports